export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14601.e4499832.jpg";